// // components/EducationHero/EducationHero.jsx
// import React from 'react';
// import './EducationHero.css';

// const EducationHero = () => {
//   return (
//     <section className="education-hero">
//       <div className="education-hero-overlay">
//         <div className="education-hero-content">
//           <h1>Empowering Future Generations</h1>
//           <p>Committed to providing quality and accessible education across Igboeze North.</p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default EducationHero;

import React from 'react';
import './EducationHero.css';

const EducationHero = () => {
  return (
    <section className="edu-hero">
      <div className="edu-hero-overlay">
        <div className="edu-hero-content">
          <h1>Education & Community Development</h1>
          <p>Building knowledge, skills, and strong communities for a better tomorrow.</p>
        </div>
      </div>
    </section>
  );
};

export default EducationHero;